import React from 'react'
import Detail from '../components/Detail';
import { useParams } from 'react-router';
import { sektorelGelismeler } from '../data/sektorel-gelismeler';


const SektorelGelismelerDetail = () => {


    const {id1} = useParams()

    const blog = sektorelGelismeler.find(item => item.link === id1);

  return (
    <div><Detail blog={blog} id1={id1}/></div>
  )
}

export default SektorelGelismelerDetail